import {
  ATTRIBUTION_PRODUCT_TYPE_VALUES,
  type AttributionCartItem,
  type AttributionClick,
  type AttributionProductType,
} from './attribution'

const ATTRIBUTION_PRODUCT_TYPES = new Set<string>(
  ATTRIBUTION_PRODUCT_TYPE_VALUES,
)

export const isString = (value: unknown): value is string =>
  typeof value === 'string' && value.length > 0

const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value)

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

const isOptionalString = (value: unknown): value is string | undefined =>
  value === undefined || isString(value)

export const isProductType = (
  value: unknown,
): value is AttributionProductType =>
  typeof value === 'string' && ATTRIBUTION_PRODUCT_TYPES.has(value)

export const isAttributionClick = (
  value: unknown,
): value is AttributionClick => {
  if (!isRecord(value)) {
    return false
  }

  return (
    isString(value.clickId) &&
    isNumber(value.createdAt) &&
    isOptionalString(value.offerId) &&
    isString(value.productId) &&
    (value.productType === undefined || isProductType(value.productType))
  )
}

export const isAttributionCartItem = (
  value: unknown,
): value is AttributionCartItem => {
  if (!isRecord(value)) {
    return false
  }

  const { quantity } = value

  return isAttributionClick(value) && isNumber(quantity)
}

export const parseStorage = (rawStorage: string): unknown => {
  try {
    const parsedStorage: unknown = JSON.parse(rawStorage)

    return parsedStorage
  } catch {
    return null
  }
}
